const testData = {
    config: {
        broadcasting: {
            pusher: {},
        },
    },
    panels: {},
    user: {},
};

export default process.env.NODE_ENV === 'test'
    ? testData
    : window.__LARASNAP_APPDATA;
